<template>
    <div>
        <Ipsative :options="responseitems" :fields="fields" :value="ipsValue" @input="ipsInput($event)"></Ipsative>
    </div>
</template>

<script>
  import Ipsative from "./components/Ipsative";
  import responseMixin from "./responseMixin";

  export default {
    name: "IpsativeResponse",
    mixins: [responseMixin],
    components: {
      Ipsative
    },
    computed: {
      responseitems() {
        return (this.responseoptions || []).map((opt) => {
          return {
            id: opt.value,
            text: this.$ta(opt.content_textassetid),
            start_event:opt.start_event,
            end_event:opt.end_event,
          };
        });
      },
      fields() {
        return this.journeyanswers.map((ans) => {
          return {
            fieldid: ans.journeyanswerid,
            text: this.$ta(ans.field.content_textassetid),
          }
        });
      },
      ipsValue() {
        if (!this.value || !this.journeyanswers) {
          return {}
        }
        const ans = {};
        for (let id of Object.keys(this.journeyanswers)) {
          const ja = this.journeyanswers[id];
          ans[ja.journeyanswerid] = this.value.answers[ja.journeyanswerid].value
        }
        return ans;
      }
    },
    methods: {
      ipsInput(obj) {
        const result = JSON.parse(JSON.stringify(this.value));
        for (let journeyanswerid of Object.keys(obj)) {
          result.answers[journeyanswerid].value = obj[journeyanswerid];
        }
        this.emitInput(result);
      }
    }
  }
</script>

<style scoped>

</style>